import { Reveal } from "@/lib/motion";

const STATS = [
  { k: "AI-native", v: "By design" },
  { k: "Early-stage", v: "Technology company" },
  { k: "Platform-first", v: "Long-term thinking" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 sm:py-40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-violet-300/80">
              06 — About
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl font-500 tracking-[-0.02em] text-white">
              An early-stage AI technology company.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <p className="text-lg sm:text-xl leading-relaxed text-white/65 font-light">
              ArcaCentum is an early-stage technology company focused on building
              and launching AI-powered software products. As the parent company,
              we develop the core technology and product vision behind a growing
              portfolio, of which{" "}
              <span className="text-white">ArcaCentum.ai</span> is the flagship.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 text-base leading-relaxed text-white/45 font-light">
              We move with the mindset of a serious technology company: deliberate,
              product-led, and built for the long term. Our focus is singular,
              creating intelligent software that turns ambitious ideas into
              real-world results.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-3 gap-5">
            {STATS.map((s, i) => (
              <Reveal key={s.k} delay={0.2 + i * 0.08}>
                <div className="glass rounded-2xl p-6" data-testid={`about-stat-${i}`}>
                  <div className="font-display text-lg font-600 text-white">{s.k}</div>
                  <div className="mt-1 text-sm text-white/40 font-light">{s.v}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
